var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-ellipsis"},[_c('el-tooltip',{attrs:{"effect":"dark","content":_vm.label,"placement":"top-start"}},[_c('span',[_vm._v(_vm._s(_vm.label))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }